import { Outlet } from "react-router";

const WithoutNavRoute = () => {
	return <Outlet />;
};

export default WithoutNavRoute;